import React from "react";

const Salvations = ({ data }) => {
  return (
    <div className="flex items-center justify-center">
      <div className="bg-white dark:bg-[#2B3674] shadow-xl rounded-full w-[160px] h-[160px] flex items-center justify-center">
        <p className="text-[40px] font-bold text-[#2B3674] dark:text-[#fff]">
          {data}%
        </p>
      </div>
    </div>
  );
};

export default Salvations;
